import { notification, NotificationPlacement } from 'ant-design-vue'
import { h } from 'vue'
import { useI18n } from 'vue-i18n'
type NotiType = 'open' | 'info' | 'success' | 'warning' | 'error'
import i18n from '../../createI18n'
const t = i18n.global.t
interface NotiOptions {
    title: string | any,
    description: string | any,
    placement?: NotificationPlacement,
    type?: NotiType,
    useCustomUI?: boolean
}

const renderContent = (title: string, description: string) => ({
    message: h('div', { class: 'title-noti' }, [
        h('span', null, title),
    ]),
    description: h('div', { class: 'content-noti' }, [
        h('span', null, description),
    ]),
})

const showNotification = ({
    title,
    description,
    placement = 'topRight',
    type = 'open',
    useCustomUI = false,
}: NotiOptions) => {
    const config = useCustomUI
        ? renderContent(title, description)
        : { message: title, description }

    notification[type]({
        ...config,
        placement,
    })
}
const messageShow = {
    show(title: string, description: string, placement?: NotificationPlacement) {
        showNotification({ title: t(title), description, placement })
    },

    info(title: string, description: string, placement?: NotificationPlacement) {
        showNotification({ title: t(title), description, placement, type: 'info' })
    },

    success(title: string, description: string, placement?: NotificationPlacement) {
        showNotification({ title: t(title), description, placement, type: 'success' })
    },

    warning(title: string, description: string, placement?: NotificationPlacement) {
        showNotification({ title: t(title), description, placement, type: 'warning' })
    },

    error(title: string, description: string, placement?: NotificationPlacement) {
        showNotification({
            title: t(title),
            description,
            placement,
            type: 'error',
            useCustomUI: true,
        })
    },

    errorCommon(msgCode: string, placement?: NotificationPlacement) {
        showNotification({
            title: t('text.server'),
            description: t(msgCode),
            placement,
            type: 'error',
            useCustomUI: true,
        })
    },

    errorList(
        title: string,
        errorsList: Record<string, string>[],
        placement?: NotificationPlacement
    ) {
        showNotification({
            title: h('div', { class: 'title-noti' }, [h('span', t(title))]),
            description: h('div', { class: 'content-noti' }, [
                renderErrorList(errorsList)
            ]),
            placement,
            type: 'error'
        })
    },

}
const renderErrorList = (
    errorsList: Record<string, string>[],
    max = 5
) => {
    if (!errorsList || errorsList.length === 0) {
        return h('span', 'Unknown error')
    }

    const items = errorsList.flatMap(err =>
        Object.entries(err).map(([field, message]) => ({
            field,
            message
        }))
    )

    const visibleItems = items.slice(0, max)

    return h('ul', { class: 'error-list' }, [
        ...visibleItems.map(item =>
            h('li', { class: 'error-item' }, [
                h('strong', { class: 'error-field' }, item.field + ': '),
                h('span', { class: 'error-message' }, item.message)
            ])
        ),
        ...(items.length > max
            ? [
                h(
                    'li',
                    { class: 'error-more' },
                    `...and ${items.length - max} more errors`
                )
            ]
            : [])
    ])
}

export default messageShow